const initialState = {
  conversations: [],
  loading: false,
  error: null,
  currentConversationId: null,
}

const conversationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CONVERSATIONS': {
      // Au lieu de remplacer complètement, fusionner intelligemment
      const incoming = action.payload || []
      const existing = state.conversations || []

      // Construire un Map pour accès rapide
      const existingMap = new Map(existing.map((conv) => [Number(conv.id), conv]))

      // Fusionner les conversations
      const merged = incoming.map((conv) => {
        const id = Number(conv.id)
        const existingConv = existingMap.get(id)

        if (!existingConv) return conv // Nouvelle conversation

        // Garder les messages existants, ajouter les nouveaux
        const messages = existingConv.messages || []
        const newMessages = conv.messages || []

        // Fusionner les messages intelligemment
        const messageIds = new Set(messages.map((m) => Number(m.id)))
        const combinedMessages = [...messages]

        for (const msg of newMessages) {
          if (!messageIds.has(Number(msg.id))) {
            combinedMessages.push(msg)
          }
        }

        // Trier par date
        combinedMessages.sort((a, b) => {
          const dateA = new Date(a.created_at || a.createdAt || 0)
          const dateB = new Date(b.created_at || b.createdAt || 0)
          return dateA - dateB
        })

        return {
          ...existingConv,
          ...conv,
          messages: combinedMessages,
          // Préserver les données importantes
          lastMessage: conv.lastMessage || existingConv.lastMessage,
          unreadCount: conv.unreadCount !== undefined ? conv.unreadCount : existingConv.unreadCount,
        }
      })

      return {
        ...state,
        conversations: merged,
      }
    }

    case 'ADD_CONVERSATION':
      return {
        ...state,
        conversations: [action.payload, ...state.conversations],
      }

    case 'UPDATE_CONVERSATION':
      return {
        ...state,
        conversations: state.conversations.map((conversation) => {
          if (conversation.id !== action.payload.id) {
            return conversation
          }

          // Mise à jour de la conversation
          const updatedConv = { ...conversation }

          // Gestion du lastMessage
          if (action.payload.lastMessage) {
            updatedConv.lastMessage = action.payload.lastMessage
          }

          // Gestion du timestamp
          if (action.payload.timestamp) {
            updatedConv.timestamp = action.payload.timestamp
            updatedConv.updatedAt = action.payload.timestamp
          }

          // Gestion des messages - PARTIE CORRIGÉE
          if (action.payload.messages) {
            if (typeof action.payload.messages === 'function') {
              // Si c'est une fonction, l'appliquer à la liste de messages existante
              updatedConv.messages = action.payload.messages(updatedConv.messages || [])
            } else if (action.payload.addMessage) {
              // Si addMessage est true, ajouter le message à la liste existante
              const newMessage = action.payload.messages

              // IMPORTANT: S'assurer que updatedConv.messages existe et est un tableau
              if (!updatedConv.messages || !Array.isArray(updatedConv.messages)) {
                updatedConv.messages = []
              }

              // Vérifier si le message n'existe pas déjà par son ID
              const messageId = Number(newMessage.id)
              const messageExists = updatedConv.messages.some((m) => Number(m.id) === messageId)

              if (!messageExists) {
                // Conserver les messages existants et ajouter le nouveau
                updatedConv.messages = [...updatedConv.messages, newMessage]

                // Trier les messages par date
                updatedConv.messages.sort((a, b) => {
                  const dateA = new Date(a.created_at || a.createdAt || 0)
                  const dateB = new Date(b.created_at || b.createdAt || 0)
                  return dateA - dateB
                })
              }
            } else {
              // Il s'agit d'une mise à jour complète
              if (Array.isArray(action.payload.messages)) {
                // Utiliser un ensemble pour suivre les IDs déjà vus
                const seenIds = new Set()
                const uniqueMessages = []

                // Parcourir les messages et n'ajouter que ceux qui n'ont pas déjà été vus
                for (const msg of action.payload.messages) {
                  const id = Number(msg.id)
                  if (!seenIds.has(id)) {
                    seenIds.add(id)
                    uniqueMessages.push(msg)
                  }
                }

                // Trier les messages par date
                uniqueMessages.sort((a, b) => {
                  const dateA = new Date(a.created_at || a.createdAt || 0)
                  const dateB = new Date(b.created_at || b.createdAt || 0)
                  return dateA - dateB
                })

                updatedConv.messages = uniqueMessages
              } else {
                updatedConv.messages = action.payload.messages
              }
            }
          }

          // Gestion du compteur de messages non lus
          if (action.payload.incrementUnread) {
            updatedConv.unreadCount = (updatedConv.unreadCount || 0) + 1
          } else if (action.payload.unreadCount !== undefined) {
            updatedConv.unreadCount = action.payload.unreadCount
          }

          return updatedConv
        }),
      }

    case 'UPDATE_CONVERSATIONS_UNREAD':
      return {
        ...state,
        conversations: state.conversations.map((c) =>
          c.id === action.payload.id ? { ...c, unreadCount: action.payload.unreadCount } : c,
        ),
      }
    case 'REMOVE_CONVERSATION':
      return {
        ...state,
        conversations: state.conversations.filter((c) => c.id !== action.payload),
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload,
      }
    case 'SET_ERROR':
      return {
        ...state,
        error: action.payload,
      }
    case 'SET_CURRENT_CONVERSATION_ID':
      return {
        ...state,
        currentConversationId: action.payload,
      }
    default:
      return state
  }
}

export default conversationsReducer
